import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, Sparkles, MessageCircle, Zap } from 'lucide-react';

const GenZPanel = ({ eli15 }) => {
  if (!eli15) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full lg:w-80 shrink-0"
      data-testid="genz-panel"
    >
      <div className="rounded-xl lg:rounded-2xl bg-slate-800/50 border border-slate-700/50 overflow-hidden">
        {/* Header */}
        <div className="p-3 lg:p-4 border-b border-slate-700/50">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg lg:rounded-xl bg-gradient-to-br from-teal-400/20 to-emerald-400/20">
              <Sparkles className="w-4 h-4 lg:w-5 lg:h-5 text-teal-400" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-white text-sm lg:text-base">ELI15</h3>
              <p className="text-xs text-slate-400">Simple explanations</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-3 lg:p-4 space-y-3 lg:space-y-4">
          {/* Emoji Summary */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="p-3 lg:p-4 rounded-lg lg:rounded-xl bg-gradient-to-br from-teal-400/10 to-emerald-400/10 border border-teal-400/20"
          >
            <div className="text-xl lg:text-2xl mb-2">{eli15.emoji_summary || '🔬📊🧬'}</div>
            <p className="text-xs lg:text-sm text-slate-300 leading-relaxed">
              {eli15.main_concept || 'Analysis in progress...'}
            </p>
          </motion.div>

          {/* Key Takeaway */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="p-3 lg:p-4 rounded-lg lg:rounded-xl bg-slate-800/50 border border-slate-700/50"
          >
            <div className="flex items-center gap-2 mb-2 lg:mb-3">
              <Lightbulb className="w-4 h-4 text-amber-400" />
              <span className="text-xs lg:text-sm font-medium text-amber-400">Key Takeaway</span>
            </div>
            <p className="text-xs lg:text-sm text-slate-300 leading-relaxed">
              {eli15.key_takeaway || 'Not clearly stated'}
            </p>
          </motion.div>

          {/* Analogies */}
          {eli15.analogies && eli15.analogies.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="space-y-2"
            >
              <div className="flex items-center gap-2 mb-2">
                <MessageCircle className="w-4 h-4 text-teal-400" />
                <span className="text-xs lg:text-sm font-medium text-teal-400">Think of it like...</span>
              </div>
              {eli15.analogies.slice(0, 2).map((analogy, index) => (
                <div
                  key={index}
                  className="p-2 lg:p-3 rounded-lg bg-slate-800/30 border border-slate-700/30"
                >
                  <div className="flex items-start gap-2">
                    <Zap className="w-3 h-3 text-teal-400 mt-0.5 shrink-0" />
                    <p className="text-xs text-slate-300 leading-relaxed">{analogy}</p>
                  </div>
                </div>
              ))}
            </motion.div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default GenZPanel;
